import { defineStore } from 'pinia'

const TOKEN_KEY = 'pc_admin_token'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem(TOKEN_KEY) || '',
    user: null,
    roles: [],
    perms: [],
    menus: []
  }),
  getters: {
    isLoggedIn: (s) => !!s.token,
    hasPerm: (s) => (perm) => s.perms.includes(perm)
  },
  actions: {
    setToken(t) {
      this.token = t
      if (t) localStorage.setItem(TOKEN_KEY, t)
      else localStorage.removeItem(TOKEN_KEY)
    },
    setInfo({ user, roles, perms, menus }) {
      this.user = user
      this.roles = roles || []
      this.perms = perms || []
      this.menus = menus || []
    },
    logoutLocal() {
      this.token = ''
      this.user = null
      this.roles = []
      this.perms = []
      this.menus = []
      localStorage.removeItem(TOKEN_KEY)
    }
  }
})
